import { getServiceRateIds } from '../../modules/entities/rates/selectors';
import { getEnterpriseServiceId } from '../../modules/entities/services/selectors';
import { ApplicationState } from '../../types';
import { WithEnterpriseId } from '../../types/selectors/selectorPropTypes';

export const getEnterpriseRateIds = (state: ApplicationState, { enterpriseId }: WithEnterpriseId) => {
    const serviceId = getEnterpriseServiceId(state, { enterpriseId });
    if (serviceId == null) {
        return [];
    }

    return getServiceRateIds(state, { serviceId });
};
